module.exports = __webpack_public_path__ + "media/images/image-preview-e974ce5d710f4d81161870c4bb5181b5.png";